// removed by extract-text-webpack-plugin
module.exports = {"FilterLabel":"style__FilterLabel___36h46","blackList":"style__blackList___38tg-","nedvex":"style__nedvex___1K3Vj","new":"style__new___ynhyM","index":"style__index___3Lj5w","index1":"style__index1___1BwyC","index2":"style__index2___1hRcG","index3":"style__index3___2qKPz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Buildings/FilterLabel/style.scss
// module id = 1316
// module chunks = 0